import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bridgeBillingOpenBilling } from '../../../slices/BridgeSlice';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

const BillingTrialMenuItem = () => {
  const dispatch = useDispatch();
  const t = useLocalizedMessage();
  const {
    billing: {
      plans: {
        isFetching = true,
        active: activeCharges = [],
        app: appInfo = {}
      } = {},
    } = {}
  } = useSelector((store) => store);
  const platformSettings = useSelector((state) => state.settings.platformSettings);
  const { bridgeApplicable } = platformSettings;

  const loading = isFetching;
  const hasActiveSub = useMemo(
    () => (activeCharges || []).some((c) => c?.status === 'active'),
    [activeCharges]
  );

  const status = appInfo?.status;
  const daysLeftRaw = appInfo?.trialDaysLeft;
  const daysLeft = Number.isFinite(daysLeftRaw) ? daysLeftRaw : undefined;

  const isTrialPhase = useMemo(
    () => ['TRIAL', 'INTEGRATION', 'TRIAL_LAST_CALL'].includes(status),
    [status]
  );
  const isDisabled = useMemo(
    () => ['ACTIVE_SWITCHED_OFF', 'SWITCH_OFF'].includes(status),
    [status]
  );

  const hideByDaysHack = Number.isFinite(daysLeft) && daysLeft > 30;
  const isEnded = Number.isFinite(daysLeft) && daysLeft <= 0;

  const shouldShowTrial =
    bridgeApplicable &&
    !loading &&
    !hasActiveSub &&
    Number.isFinite(daysLeft) &&
    !hideByDaysHack &&
    (isTrialPhase || isEnded);

  const shouldShowDisabled =
    bridgeApplicable &&
    !loading &&
    isDisabled;

  const shouldShow = shouldShowTrial || shouldShowDisabled;

  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (shouldShow) setVisible(true);
  }, [shouldShow]);

  const handleClick = () => {
    dispatch(bridgeBillingOpenBilling());
  };

  if (!shouldShow) return null;

  let label;
  if (isDisabled) {
    label = t('billing.menu.serviceDisabled');
  } else if (isEnded) {
    label = t('billing.menu.trialEnded');
  } else {
    label = t('billing.menu.trialDaysLeft', { days: daysLeft });
  }

  return (
    <li
      className="nav-item"
      onClick={handleClick}
      style={{
        marginLeft: 'auto',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        opacity: visible ? 1 : 0,
        transition: 'opacity 200ms ease',
        cursor: 'pointer'
      }}
      title={t('billing.menu.open')}
    >
      <div
        className="nav-link"
        style={{ paddingRight: 0, display: 'flex', alignItems: 'center' }}
      >
        <i className="zmdi zmdi-time-restore" style={{ marginRight: 8 }}/>
        {label}
      </div>
    </li>
  );
};

export default BillingTrialMenuItem;
